import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {Scan3dModel} from '../../../api/entity/scan3d.model';

@Injectable()
export class Scan3dRepository extends AbstractRepositoryV2<Scan3dModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Scan3d', serviceElementsFactory, injector);
    }
}
